module.exports = __webpack_public_path__ + "img/gaoxiaojin.110ed402.jpg";